// extracted by mini-css-extract-plugin
module.exports = {"fullpagewrapper":"FullPageError_fullpagewrapper__3N2dM","buttons":"FullPageError_buttons__FsFTH"};